module.exports = function(service) {
	'use strict'
	service.factory('tabSessionService', tabSessionService);
	tabSessionService.$inject = ['$window'];
	
	function tabSessionService($window) {
		var sessionStorage = $window.sessionStorage;
		var SESSION_ID_KEY = 'tabSessionId';

		// Cache tab type on load factory and cache session id after first call to getSessionId
		var sessionIdCache = '';
		var navType = $window.performance.navigation.type;
		
		// Generate a unique session ID
		function generateSessionId() {
			return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
		}
		
		// Check if this tab was duplicated
		function isTabDuplicated(navType) {
			// TYPE_NAVIGATE = 0 (new navigation/duplicated)
			// TYPE_RELOAD = 1 (reload)
			// TYPE_BACK_FORWARD = 2 (back/forward/duplicated tab firefox)
			
			if (navType !== 1) {
				// This is a new navigation, likely duplicated tab	
				return true;
			}
			return false;
		}
		
		// Get or create session ID for current tab
		function getSessionId() {
			if(sessionIdCache) {
				return sessionIdCache;
			}
			var sessionId = sessionStorage.getItem(SESSION_ID_KEY);
			// If no session ID exists, create one
			if (!sessionId) {
				sessionId = generateSessionId();
				sessionStorage.setItem(SESSION_ID_KEY, sessionId);
			}
			
			// If tab was duplicated, generate new session ID
			else if (isTabDuplicated(navType)) {
				sessionId = generateSessionId();
				sessionStorage.setItem(SESSION_ID_KEY, sessionId);
			}
			sessionIdCache = sessionId;
			
			return sessionId;
		}
		
		// Get session info for current tab
		function getSessionInfo() {
			var sessionId = getSessionId();
			
			return {
				sessionId: sessionId,
				isDuplicated: isTabDuplicated()
			};
		}
		
		return {
			getSessionId: getSessionId,
			getSessionInfo: getSessionInfo
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/tabSessionService.js
// module id = 629
// module chunks = 0